export default __webpack_public_path__ + "static/media/fluster_game_background_large.92f36fc2.png";